"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.polyfillArrayFind = polyfillArrayFind;
function polyfillArrayFind() {
    if (typeof Array.prototype.find !== 'undefined') {
        return;
    }
    console.warn('Polyfill required for Array.prototype.find()');
    Array.prototype.find = function (callback) {
        for (var i = 0; i < this.length; i++) {
            var element = this[i];
            if (callback.call(this, element, i, this)) {
                return element;
            }
        }
        return undefined;
    };
}
